import React from 'react';
import { CustomTooltip } from './Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    display: 'inline-block',
    fontWeight: 'bold',
    '&:hover': { cursor: 'default' },
  },
}));

export default function DesktopTip({ text, tooltip }) {
  const classes = useStyles();

  return (
    <CustomTooltip arrow title={<Typography>{tooltip}</Typography>}>
      <Typography paragraph variant="h6" className={classes.tooltip}>
        {text}
      </Typography>
    </CustomTooltip>
  );
}
